import { useState } from 'react';
import { PageContainer } from '../../../shared/components/PageContainer';
import { DadosBancariosTab } from '../components/DadosBancariosTab';
import { EnderecosContatosTab } from '../components/EnderecosContatosTab';

type Aba = 'enderecos' | 'bancarios';

/**
 * Autosserviço do colaborador (US-GP-003/004): endereços (com aprovação do
 * DP), contatos, contatos de emergência e contas bancárias (com validação).
 */
export default function MeusDadosPage() {
  const [aba, setAba] = useState<Aba>('enderecos');
  const owner = { kind: 'me' as const };
  return (
    <PageContainer title="Meus dados" subtitle="Mantenha seus endereços, contatos e dados bancários atualizados.">
      <section className="rounded-lg border border-gray-200 bg-white shadow-sm">
        <div className="flex border-b border-gray-200">
          {([['enderecos', 'Endereços e contatos'], ['bancarios', 'Dados bancários']] as const).map(([key, label]) => (
            <button
              key={key}
              type="button"
              onClick={() => setAba(key)}
              className={`px-4 py-3 text-sm font-medium ${aba === key ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
            >
              {label}
            </button>
          ))}
        </div>
        <div className="p-5">
          {aba === 'enderecos' ? <EnderecosContatosTab owner={owner} canEdit /> : <DadosBancariosTab owner={owner} canCreate />}
        </div>
      </section>
    </PageContainer>
  );
}
